import { useEffect, useState } from "react";
import { TablePagination } from "@mui/material";

/** Same rows-per-page choices as the Papers billing tab. */
export const BILLING_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];
export const BILLING_DEFAULT_ROWS_PER_PAGE = 10;

/**
 * Client-side paging used by every parent/student Billing tab.
 *
 * `resetKey` should change when filters change so we jump back to the first page
 * instead of leaving the user on an empty later page.
 */
export function useBillingPagination(resetKey = "") {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(BILLING_DEFAULT_ROWS_PER_PAGE);

  useEffect(() => {
    setPage(0);
  }, [resetKey]);

  const handleChangePage = (_event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginate = (items) => {
    const list = Array.isArray(items) ? items : [];
    const maxPage = Math.max(0, Math.ceil(list.length / rowsPerPage) - 1);
    const currentPage = Math.min(page, maxPage);
    return {
      page: currentPage,
      count: list.length,
      rows: list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage),
    };
  };

  return {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    paginate,
  };
}

/** MUI TablePagination matching the Papers billing tab. Hidden when the list is empty. */
export default function BillingPagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) {
  if (!count) return null;

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={BILLING_ROWS_PER_PAGE_OPTIONS}
      sx={{
        borderTop: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    />
  );
}
